// Función para mapear datos del formulario al formato de Tecnóm
export const mapFormDataToTecnom = (formData) => {
  const currentDate = new Date().toISOString();

  // Mapear el tipo de operación según la selección del usuario
  const operationType =
    formData.acquisition === "Plan"
      ? "Plan de Ahorro"
      : formData.acquisition === "Venta Directa"
      ? "Venta Directa"
      : formData.acquisition;

  // Determinar el origen: priorizar utm_source si existe
  let origin;
  if (formData.utm_source) {
    // Si utm_source es "blog", usar "MEDIOS_TRADICIONALES", sino usar el utm_source directamente
    if (formData.utm_source.toLowerCase() === "blog") {
      origin = "MEDIOS_TRADICIONALES";
    } else {
      origin = formData.utm_source;
    }
  } else {
    origin = "directo";
  }

  const suborigen = formData.utm_medium || formData.medio || "landing_consultas";
  const campaign = formData.utm_campaign || null;
  const providerName = `${origin} - ${suborigen}`;
  const acquisitionType =
    formData.acquisition === "Plan" ? "plan" : formData.acquisition === "Venta Directa" ? "venta directa" : "otro";
  const providerService = `${suborigen} - ${acquisitionType} en la web`;

  // Incluir UTM en comentarios para que Tecnóm tenga el mismo tracking que WhatsApp
  const utmComment = [
    formData.utm_source && `utm_source: ${formData.utm_source}`,
    formData.utm_medium && `utm_medium: ${formData.utm_medium}`,
    formData.utm_campaign && `utm_campaign: ${formData.utm_campaign}`,
    formData.utm_content && `utm_content: ${formData.utm_content}`,
  ]
    .filter(Boolean)
    .join(" | ");
  const comments = [formData.comments, `Tipo de operación: ${operationType}`, utmComment].filter(Boolean).join(" - ");

  return {
    contact: {
      full_name: formData.name,
      email: {
        value: formData.email,
        type: "work",
      },
      phone: formData.phone,
      mobile_phone: formData.phone,
    },
    product: formData.brand,
    comments,
    medium: suborigen,
    sub_origin: suborigen,
    origin: origin,
    campaign,
    provider_name: providerName,
    provider_service: providerService,
    requested_at: currentDate,
    first_contacted_at: currentDate,
    // Campos UTM explícitos por si la API de Tecnóm los usa
    utm_source: formData.utm_source || null,
    utm_medium: formData.utm_medium || null,
    utm_campaign: formData.utm_campaign || null,
    utm_content: formData.utm_content || null,
  };
};

